// Role-Based Access Control map
// key = menu id (matches NAV item id / route)
// value = "*" (all roles) or array of allowed roles

// Menu keys used in Layout NAV
export const MENUS = {
  DASHBOARD: "dashboard",
  SANTRI: "santri",
  USTAZ: "ustaz",
  ABSENSI_SANTRI: "absensi-santri",
  ABSENSI_GURU: "absensi-guru",
  DIVISI_KEIBADAHAN: "divisi-keibadahan",
  DIVISI_LUGHO: "divisi-lugho",
  DIVISI_KEDISIPLINAN: "divisi-kedisiplinan",
  DIVISI_KEBERSIHAN: "divisi-kebersihan",
  DIVISI_KEAMANAN: "divisi-keamanan",
  DIVISI_KESEHATAN: "divisi-kesehatan",
  DIVISI_TAHFIZ: "divisi-tahfiz",
  DIVISI_HUMAS: "divisi-humas",
  DIVISI_LOGISTIK: "divisi-logistik",
  PELANGGARAN: "pelanggaran",
  PERIZINAN: "perizinan",
  MAKAN: "makan",
  KEGIATAN: "kegiatan",
  TAHFIZ: "tahfiz",
  LAPORAN: "laporan",
  PENGATURAN: "pengaturan",
  AUDIT: "audit",
  BACKUP: "backup",
  USERS: "users",
};

const ALL = "*";

// Menu → allowed roles. Admin always has access.
export const MENU_ACCESS = {
  [MENUS.DASHBOARD]: ALL,
  [MENUS.SANTRI]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.USTAZ]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.ABSENSI_SANTRI]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.ABSENSI_GURU]: ["pimpinan", "musyrif", "ustazah_asrama", "koordinator_tahfiz", "kepala_kedisiplinan"],
  [MENUS.DIVISI_KEIBADAHAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_keibadahan"],
  [MENUS.DIVISI_LUGHO]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_lugho"],
  [MENUS.DIVISI_KEDISIPLINAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_kedisiplinan"],
  [MENUS.DIVISI_KEBERSIHAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_kebersihan"],
  [MENUS.DIVISI_KEAMANAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_keamanan"],
  [MENUS.DIVISI_KESEHATAN]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.DIVISI_TAHFIZ]: ["pimpinan", "musyrif", "ustazah_asrama", "koordinator_tahfiz", "guru"],
  [MENUS.DIVISI_HUMAS]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_humas"],
  [MENUS.DIVISI_LOGISTIK]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_logistik"],
  [MENUS.PELANGGARAN]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.PERIZINAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_humas"],
  [MENUS.MAKAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_logistik"],
  [MENUS.KEGIATAN]: ["pimpinan", "musyrif", "ustazah_asrama", "kepala_kedisiplinan", "kepala_keamanan"],
  [MENUS.TAHFIZ]: [],  // MERGED into Divisi Tahfiz — hide standalone menu
  [MENUS.LAPORAN]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.PENGATURAN]: [],
  [MENUS.AUDIT]: [],
  [MENUS.BACKUP]: ["pimpinan", "musyrif", "ustazah_asrama"],
  [MENUS.USERS]: [],  // admin only — ustazah_asrama CANNOT manage users per requirement
};

export function canAccess(role, menu) {
  if (!role) return false;
  if (role === "admin") return true;
  const rule = MENU_ACCESS[menu];
  if (rule === ALL) return true;
  if (Array.isArray(rule)) return rule.includes(role);
  return false;
}

// For DivisiPage — check if the current user has access to a specific divisi slug
export function canAccessDivisi(role, divisiSlug) {
  const menuMap = {
    keibadahan: MENUS.DIVISI_KEIBADAHAN,
    lugho: MENUS.DIVISI_LUGHO,
    kedisiplinan: MENUS.DIVISI_KEDISIPLINAN,
    kebersihan: MENUS.DIVISI_KEBERSIHAN,
    keamanan: MENUS.DIVISI_KEAMANAN,
    kesehatan: MENUS.DIVISI_KESEHATAN,
    humas: MENUS.DIVISI_HUMAS,
    logistik: MENUS.DIVISI_LOGISTIK,
  };
  return canAccess(role, menuMap[divisiSlug]);
}
